<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.create_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Registrar Alumno</v-toolbar-title>
            </v-toolbar>
            <v-container>
                <v-form v-model="form" ref="create" v-on:submit.prevent="submit($event)">
                    <v-row>
                        <v-col cols="12" lg="6" md="10" class="mx-auto">
                            <v-text-field v-model="names" :rules="[rules.required]" filled label="Nombre(s)" clearable :color="color" append-icon="mdi-account"></v-text-field>
                            <v-row no-gutters>
                                <v-text-field v-model="paternal_surname" :rules="[rules.required]" filled label="Apellido paterno" clearable :color="color"></v-text-field>
                                <v-text-field v-model="maternal_surname" :rules="[rules.required]" filled label="Apellido materno" clearable :color="color"></v-text-field>
                                <vue-tel-input-vuetify
                                    placeholder="Whatsapp"
                                    @input="onInput"
                                    :rules="[rules.required, rules.phone]"
                                    :onlyCountries="['mx', 'co', 'uy', 'pe', 'cl', 'ar']"
                                    :required="true"
                                    label=""
                                    @country-changed="updateCountry"
                                    outlined
                                ></vue-tel-input-vuetify>
                            </v-row>
                            <p>Datos de usuario</p>
                            <v-text-field
                                v-model="email"
                                filled
                                label="Correo electrónico"
                                :error-messages="email_error_messages"
                                :rules="[rules.required, rules.email]"
                                clearable
                                :color="color"
                                append-icon="mdi-at"
                            ></v-text-field>
                            <v-text-field
                                v-model="name"
                                filled
                                label="Nombre de usuario"
                                :error-messages="name_error_messages"
                                clearable
                                :rules="[rules.required]"
                                :color="color"
                                append-icon="mdi-account-circle"
                            ></v-text-field>
                            <v-row no-gutters>
                                <v-text-field v-model="password" type="password" :rules="[rules.required, rules.length]" hint="Debe contener al menos 8 caracteres" filled label="Contraseña" :color="color"></v-text-field>
                                <v-text-field v-model="password_confirmation" :error-messages="error_message" ref="password_confirmation" type="password" :rules="[rules.required]" filled label="Repetir contraseña" :color="color"></v-text-field>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" lg="6" md="10" class="text-right mx-auto">
                            <v-btn type="submit" :loading="loading" color="#008dd4" dark>Registrar</v-btn>
                            <v-btn @click="cancel" :disabled="loading" text>Cancelar</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog', 'store_url'],
    data:() => ({
        color:"#000",
        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido',
            length: v  => !!v && v.length >= 8 || 'Debe contener al menos 8 caracteres',
            phone: v => !!v && v.length >= 10 || 'Debe contener al menos 10 caracteres'
        },

        form:false,

        //props
        color: "#000",
        loading:false,
        email_error_messages:"",
        name_error_messages:"",
        error_message:"",

        names:"",
        paternal_surname:"",
        maternal_surname:"",
        email:"",
        name:"",
        password:"",
        password_confirmation:"",
        phone:"",
        country: null,
        phone_valid:false,

    }),

    watch:{
        password:function(val){
            this.password_confirmation = ""

        },

        password_confirmation:function(val){
            if(val !== ""){
                this.error_message = val !== this.password ? "Las contraseñas no coinciden" : ""
            }else{
                this.$refs.password_confirmation.reset()
            }
        }
    },

    methods:{
        onInput(formattedNumber, { number, valid, country }) {
            this.phone = number.e164
            this.phone_valid = valid
        },
        updateCountry(country) {
            this.country = country;
        },
        submit:function(){
            if(this.$refs.create.validate()){
                this.loading = true

                let data = new Object()
                data.name                  = this.name
                data.names                 = this.names
                data.phone                 = this.phone
                data.country_code                 = this.country.iso2
                data.email                 = this.email
                data.password              = this.password
                data.paternal_surname      = this.paternal_surname
                data.maternal_surname      = this.maternal_surname
                data.password_confirmation = this.password_confirmation

                axios.post(this.store_url, data).then(response => {
                    if(response.data.success){
                        this.cancel()

                        iziToast.success({
                            title:"Correcto",
                            position:"topRight",
                            message:"Alumno registrado correctamente"
                        })

                        this.$parent.getData()
                    }
                }).catch(error => {
                    this.loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }
                })

            }
        },

        cancel:function(){
            this.loading = false
            this.$refs.create.reset()
            this.$parent.create_dialog = false
        }

    }

}
</script>
